import { XPorterSchoolModel } from './XPorterSchoolModel';

export { XPorterSchoolModel };
